import { ITongHopDinhKySelectRequest } from "../models/request/tong-hop/ITongHopDinhKyRequest";
import { apiClient } from "./apiClient";
export const TONG_HOP_DINH_KY_ENDPOINT = "tong-hop-dinh-ky"
export const tongHopDinhKyApi = {
    selectMonHocs: (lopId: number) =>
        apiClient.get(`${TONG_HOP_DINH_KY_ENDPOINT}/lop/${lopId}/mon-hoc`),
    selectKetQuas: (request: ITongHopDinhKySelectRequest) =>
        apiClient.post(`${TONG_HOP_DINH_KY_ENDPOINT}/ket-qua`, request)
}